import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { Observable, catchError, map } from 'rxjs';
import { AppSettingsService } from 'src/app/core/app-settings.service';
import { parseResponse } from 'src/app/core/helpers';
import { UOM } from 'src/app/core/module/uom-interface';
const httpOptions = {
  headers: new HttpHeaders({ 'Content-Type': 'application/json' })
};
interface UOMResponse {
  items: UOM[];
  totalCount: number;
  error: string;
}
@Injectable({
  providedIn: 'root'
})
export class UOMService {
  constructor(
    private http: HttpClient,
    private appSettingsService: AppSettingsService
  ) {}

  getUOM(queryParams: any): Observable<any> {
    let params = this.appSettingsService.queryStringFormat(queryParams);

    return this.http.get('uom/list?' + params, httpOptions).pipe(
      map((resp: any) => {
        let retData: any = {
          items: [],
          totalCount: 0,
          error: ''
        };

        if (
          resp &&
          resp.data &&
          Array.isArray(resp.data.rows) &&
          resp?.error?.code <= 0
        ) {
          let rows = resp.data.rows;
          for (const item of rows) {
            let temp: UOM = {
              id: item.id,
              name: item.name,
              abbreviation: item.abbrevation,
              inputType: item.inputType,
              operator: item.operator
            };
            retData.items.push(temp);
          }

          retData.totalCount = resp.data.count;
        } else {
          retData.error = resp?.error?.message ? resp.error.message : '';
        }

        return retData;
      })
    );
  }

  createUOM(data: UOM): Observable<any> {
    return this.http.post('uom/create', data, httpOptions).pipe(
      map((resp) => {
        return parseResponse(resp);
      })
    );
  }

  getByUOMId(id: any) {
    return this.http.get('uom/' + id).pipe(
      map((resp: any) => {
        let Uom: any;
        if (resp && resp.data) {
          let data = resp.data;
          Uom = data;
        }
        return Uom;
      })
    );
  }

  updateUOM(id: any, data: UOM): Observable<any> {
    return this.http.put('uom/' + id, data, httpOptions).pipe(
      map((resp) => {
        return parseResponse(resp);
      })
    );
  }

  deleteUOM(id: any): Observable<any> {
    return this.http.delete('uom/' + id, httpOptions).pipe(
      map((resp) => {
        return parseResponse(resp);
      })
    );
  }

  //handle error messages
  handleError(err: any) {
    this.appSettingsService.handleError(err);
  }

  getAllUOM(): Observable<UOMResponse> {
    return this.http.get<any>('uom/list', httpOptions).pipe(
      map((resp: any) => {
        const retData: UOMResponse = {
          items: [],
          totalCount: 0,
          error: ''
        };

        if (
          resp?.data?.rows &&
          Array.isArray(resp.data.rows) &&
          resp?.error?.code <= 0
        ) {
          retData.items = resp.data.rows.map((item: any) => ({
            ...item
          }));
          retData.totalCount = resp.data.count || 0;
        } else {
          retData.error =
            resp?.error?.message || 'An error occurred while fetching UOM data';
        }

        return retData;
      }),
      catchError((error) => {
        console.error('Error in getAllUOM:', error);
        return [
          {
            items: [],
            totalCount: 0,
            error: 'An unexpected error occurred. Please try again later.'
          }
        ];
      })
    );
  }
}
